import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {AbstractFilter} from './AbstractFilter';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class NoWinFilter extends AbstractFilter {
    constructor(public name: string) {
        super(name);
    }

    public filter(response: Message, session: Session): boolean {
        const action = response.getAction();

        if (action !== Action.SPIN && action !== Action.FREESPIN && action !== Action.RESPIN &&
            // @ts-ignore TODO: refactoring required!
            action !== Action.MINISPIN && action !== Action.BUY_FEATURE
        ) {
            return true;
        }

        return this.getWin(response) === 0;
    }

    protected getWin(response: Message): number {
        let win = 0;

        for (const pay of this.getSpin(response).pays) {
            win += pay.win;
        }

        return win;
    }
}
